import { SafetyCopilotHome } from './pages/Home';

export default [{ path: '', element: <SafetyCopilotHome /> }];
